import React, { Component } from 'react'
import { uploadToFilestack } from '../../../../lib/filestack'
import { updatePage } from 'supporticon/api/pages'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import AvatarEditor from 'react-avatar-editor'
import Button from 'constructicon/button'
import Dropzone from 'react-dropzone'
import Form from 'constructicon/form'
import Slider from '../Slider'
import SuccessMessage from '../SuccessMessage'

class EditProfilePictureForm extends Component {
  constructor () {
    super()
    this.handleSubmit = this.handleSubmit.bind(this)
    this.state = {
      image: null,
      status: null,
      zoom: 100,
      step: 0
    }
  }

  handleSubmit (e) {
    e.preventDefault()

    const { pageId, user } = this.props
    const canvas = this.editor.getImageScaledToCanvas()
    const image = canvas.toDataURL('image/jpeg', 1)

    return Promise.resolve()
      .then(() => this.setState({ status: 'fetching', step: 1 }))
      .then(() => uploadToFilestack(image, pageId))
      .then(url => {
        this.setState({ step: 2 })
        return updatePage(pageId, { image: url, authType: user.authType, token: user.token })
      })
      .then(() => this.setState({ status: 'fetched', step: 0 }))
      .catch(error => {
        this.setState({ status: 'failed', step: 0 })
        return Promise.reject(error)
      })
  }

  getCurrentStep () {
    const { step } = this.state

    switch (step) {
      case 1:
        return 'Processing Image (Step 1 of 2)'
      case 2:
        return 'Uploading Image (Step 2 of 2)'
      default:
        return 'Update'
    }
  }

  render () {
    const { classNames } = this.props
    const { image, status, zoom } = this.state

    if (!image) {
      return (
        <Dropzone
          accept='image/*'
          className={classNames.dropzone}
          onDrop={images => this.setState({ image: images[0] })}>
          <div className={classNames.content}>
            <Button>Select Image</Button>
            <p>By clicking to browse or dropping a file into this area</p>
          </div>
        </Dropzone>
      )
    }

    return (
      <div className={classNames.root}>
        <AvatarEditor
          className={classNames.editor}
          border={25}
          color={[255, 255, 255, 0.5]}
          image={image}
          width={800}
          height={800}
          ref={el => { this.editor = el }}
          rotate={0}
          scale={zoom / 100}
        />
        <button
          className={classNames.clear}
          onClick={() => this.setState({ image: null })}>
          Clear Image
        </button>
        <p>Zoom/scale image</p>
        <Slider value={zoom} onChange={zoom => this.setState({ zoom })} />
        <Form
          icon={false}
          isLoading={status === 'fetching'}
          noValidate
          onSubmit={this.handleSubmit}
          submit={this.getCurrentStep()}
          footer={
            <div className={classNames.note}>
              Please be patient, your new profile picture can take up to 2 minutes to appear on your page.
            </div>
          }
        />
        <SuccessMessage visible={status === 'fetched'}>
          Profile picture successfully updated
        </SuccessMessage>
      </div>
    )
  }
}

export default withStyles(styles)(EditProfilePictureForm)
